import React from "react";
import "./RecentMailListCard.css";

const AVATAR_COLORS = [
  "#E01E5A", "#36C5F0", "#2EB67D", "#ECB22E",
  "#E8912D", "#9B59B6", "#1D9BD1", "#4A154B",
];

export function parseFrom(from) {
  if (!from) return "";
  const nameEmailMatch = from.match(/^(.+?)\s*<[^>]+>$/);
  if (nameEmailMatch) return nameEmailMatch[1].trim().replace(/"/g, "");
  const emailOnlyMatch = from.match(/^([^@\s]+)@/);
  if (emailOnlyMatch) return emailOnlyMatch[1];
  return from.replace(/"/g, "");
}

function getInitials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

function getAvatarColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function formatSlackDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  const now = new Date();

  if (date.toDateString() === now.toDateString()) {
    return date.toLocaleTimeString("ko-KR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  }

  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (date.toDateString() === yesterday.toDateString()) {
    return "어제";
  }

  if (date.getFullYear() === now.getFullYear()) {
    return date.toLocaleDateString("ko-KR", { month: "numeric", day: "numeric" });
  }

  return date.toLocaleDateString("ko-KR", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
}

function MailSlackList({
  title = "최근 메일",
  mails = [],
  loading = false,
  error = null,
  limit = 5,
  onMoreClick,
  onMailClick,
}) {
  return (
    <div className="mail-slack-card card mb-3 flex-grow-1">
      <div className="mail-slack-card-body card-body">
        <div className="mail-slack-header">
          <h4 className="mail-slack-title">{title}</h4>
          <button type="button" className="mail-slack-more-btn" onClick={onMoreClick}>
            더보기
          </button>
        </div>

        {loading ? (
          <p className="mail-slack-status">불러오는 중...</p>
        ) : error ? (
          <p className="mail-slack-status error">오류: {error}</p>
        ) : mails.length === 0 ? (
          <p className="mail-slack-status">메일이 없습니다.</p>
        ) : (
          <ul className="mail-slack-list">
            {mails.slice(0, limit).map((mail) => {
              const sender = parseFrom(mail.from);
              const isUnread = !mail.seen;

              return (
                <li
                  key={mail.uid}
                  className={`mail-slack-item${isUnread ? " unread" : ""}`}
                  onClick={() => onMailClick?.(mail)}
                  title={mail.subject}
                >
                  {isUnread && <span className="mail-slack-unread-dot" aria-hidden="true" />}
                  <div
                    className="mail-slack-avatar"
                    style={{ backgroundColor: getAvatarColor(sender) }}
                    aria-hidden="true"
                  >
                    {getInitials(sender)}
                  </div>
                  <div className="mail-slack-content">
                    <div className="mail-slack-row-top">
                      <span className="mail-slack-sender">{sender || "(알 수 없음)"}</span>
                      <span className="mail-slack-time">{formatSlackDate(mail.date)}</span>
                    </div>
                    <div className="mail-slack-subject">{mail.subject || "(제목 없음)"}</div>
                    {mail.preview ? (
                      <div className="mail-slack-preview">{mail.preview}</div>
                    ) : null}
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

export default MailSlackList;
